import React from "react";
import { useNavigate } from "react-router-dom";

function LiveModerationDemoPage() {
  const navigate = useNavigate();

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/lives-show");
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999999,
        overflowY: "auto",
        background:
          "radial-gradient(circle at top right, rgba(0,242,255,0.24), transparent 30%), radial-gradient(circle at bottom left, rgba(255,0,90,0.18), transparent 32%), #03070d",
        color: "#fff",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <style>
        {`
          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }

          @keyframes shieldPulse {
            0%, 100% { transform: scale(1); box-shadow: 0 0 22px rgba(0,242,255,0.35); }
            50% { transform: scale(1.06); box-shadow: 0 0 55px rgba(0,242,255,0.85); }
          }

          @keyframes scanDown {
            0% { top: 0; opacity: 0; }
            15% { opacity: 1; }
            100% { top: 100%; opacity: 0; }
          }

          @keyframes alertSlide {
            0% { transform: translateX(120%); opacity: 0; }
            15% { transform: translateX(0); opacity: 1; }
            80% { transform: translateX(0); opacity: 1; }
            100% { transform: translateX(120%); opacity: 0; }
          }

          @keyframes checkPop {
            0% { transform: scale(0.4); opacity: 0; }
            45% { transform: scale(1.25); opacity: 1; }
            100% { transform: scale(1); opacity: 1; }
          }

          .scan-line-security {
            position: absolute;
            left: 0;
            right: 0;
            height: 4px;
            background: linear-gradient(90deg, transparent, #00f2ff, transparent);
            box-shadow: 0 0 22px rgba(0,242,255,0.9);
            animation: scanDown 3s linear infinite;
          }

          .moderation-alert {
            animation: alertSlide 4s ease-in-out infinite;
          }

          .safe-check {
            animation: checkPop 2.8s ease-in-out infinite;
          }
        `}
      </style>

      <button
        onClick={goBack}
        style={{
          position: "fixed",
          top: 22,
          left: 22,
          zIndex: 10000000,
          padding: "11px 18px",
          borderRadius: 16,
          border: "1px solid rgba(0,242,255,0.45)",
          background: "rgba(0, 12, 20, 0.9)",
          color: "#00f2ff",
          fontWeight: 900,
          cursor: "pointer",
          boxShadow: "0 0 18px rgba(0,242,255,0.25)",
        }}
      >
        ← Retour
      </button>

      <div
        style={{
          minHeight: "100vh",
          padding: "80px 18px 50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            fontSize: 42,
            margin: "0 0 12px",
            fontWeight: 900,
            textShadow: "0 0 22px rgba(0,242,255,0.75)",
            animation: "fadeUp 0.7s ease forwards",
          }}
        >
          🛡️ Modération live
        </h1>

        <p
          style={{
            maxWidth: 760,
            color: "#9befff",
            fontSize: 18,
            lineHeight: 1.6,
            marginBottom: 34,
            animation: "fadeUp 0.9s ease forwards",
          }}
        >
          Un environnement plus sûr grâce aux outils de signalement,
          de contrôle et de modération active.
        </p>

        <div
          style={{
            width: "100%",
            maxWidth: 760,
            borderRadius: 34,
            background:
              "linear-gradient(180deg, rgba(8,22,34,0.95), rgba(2,6,12,0.98))",
            border: "1px solid rgba(0,242,255,0.35)",
            boxShadow: "0 0 45px rgba(0,242,255,0.22)",
            padding: 26,
            position: "relative",
            overflow: "hidden",
            animation: "fadeUp 1.1s ease forwards",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: 18,
            }}
          >
            <div
              style={{
                minHeight: 420,
                borderRadius: 30,
                background:
                  "linear-gradient(180deg, rgba(0,0,0,0.38), rgba(0,0,0,0.62))",
                border: "1px solid rgba(0,242,255,0.22)",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <div className="scan-line-security" />

              <div
                style={{
                  position: "absolute",
                  top: 18,
                  left: 18,
                  display: "flex",
                  gap: 10,
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    background: "#ff005a",
                    padding: "7px 12px",
                    borderRadius: 999,
                    fontSize: 12,
                    fontWeight: 900,
                  }}
                >
                  LIVE
                </span>

                <span
                  style={{
                    background: "rgba(0,0,0,0.45)",
                    padding: "7px 12px",
                    borderRadius: 999,
                    fontSize: 12,
                    color: "#d9fbff",
                    border: "1px solid rgba(0,242,255,0.18)",
                  }}
                >
                  Surveillance active
                </span>
              </div>

              <div
                style={{
                  position: "absolute",
                  top: "31%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 145,
                  height: 145,
                  borderRadius: "50%",
                  border: "2px solid rgba(0,242,255,0.65)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 62,
                  animation: "shieldPulse 2.2s ease-in-out infinite",
                  background:
                    "radial-gradient(circle, rgba(0,242,255,0.22), rgba(0,242,255,0.04), transparent 70%)",
                }}
              >
                🛡️
              </div>

              <div
                className="moderation-alert"
                style={{
                  position: "absolute",
                  top: 235,
                  right: 18,
                  left: 18,
                  padding: 14,
                  borderRadius: 18,
                  background: "rgba(255, 0, 90, 0.16)",
                  border: "1px solid rgba(255, 0, 90, 0.45)",
                  color: "#fff",
                  fontSize: 14,
                  textAlign: "left",
                }}
              >
                🚨 Signalement reçu : comportement suspect détecté.
              </div>

              <div
                style={{
                  position: "absolute",
                  bottom: 22,
                  left: 18,
                  right: 18,
                  padding: 14,
                  borderRadius: 18,
                  background: "rgba(0,242,255,0.08)",
                  border: "1px solid rgba(0,242,255,0.22)",
                  color: "#d9fbff",
                  fontSize: 14,
                  lineHeight: 1.45,
                }}
              >
                Analyse automatique du live, suivi des alertes et protection de
                la communauté.
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 14,
              }}
            >
              {[
                ["🚫", "Anti-spam", "Détection des messages répétés et comportements abusifs."],
                ["⚠️", "Signalements", "Les utilisateurs peuvent signaler un contenu en quelques secondes."],
                ["👮", "Outils staff", "Les équipes peuvent vérifier, masquer ou intervenir rapidement."],
                ["✅", "Live sécurisé", "Une expérience plus saine pour les créateurs et les spectateurs."],
              ].map(([icon, title, text], index) => (
                <div
                  key={title}
                  style={{
                    padding: 18,
                    borderRadius: 22,
                    background:
                      index === 3
                        ? "rgba(0,242,255,0.12)"
                        : "rgba(0,0,0,0.32)",
                    border:
                      index === 3
                        ? "1px solid rgba(0,242,255,0.45)"
                        : "1px solid rgba(0,242,255,0.18)",
                    textAlign: "left",
                    boxShadow:
                      index === 3
                        ? "0 0 25px rgba(0,242,255,0.18)"
                        : "none",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                      marginBottom: 8,
                    }}
                  >
                    <span
                      className={index === 3 ? "safe-check" : ""}
                      style={{ fontSize: 26 }}
                    >
                      {icon}
                    </span>

                    <strong style={{ color: "#fff", fontSize: 17 }}>
                      {title}
                    </strong>
                  </div>

                  <p
                    style={{
                      margin: 0,
                      color: "#9befff",
                      fontSize: 14,
                      lineHeight: 1.45,
                    }}
                  >
                    {text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LiveModerationDemoPage;
